import { 
    USER_BIND, 
    UN_BIND, 
    AUTH_CODE,
    EMAIL_VALID 
} from "Actions/bind";

const initialState = {

};

let payload = {}

export function bind(state = initialState, action) {
    switch (action.type) {
        case USER_BIND:
            payload = action.payload

            return Object.assign({}, state, { customerUser: payload });
        case UN_BIND:
            payload = action.payload

            return Object.assign({}, state, { unBind: payload});
        case EMAIL_VALID:
            payload = action.payload

            return Object.assign({}, state, { emailValid: payload});
        case AUTH_CODE:
            payload = action.payload

            return Object.assign({}, state, { authCode: payload});
        default:
            return state;
    }
}
